var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-main-container" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitBusinessData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "card setting-card" }, [
          _c("div", { staticClass: "page-header" }, [
            _c("h3", { staticClass: "page-title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "profile.rescheduling_restructuring.detail_rescheduling_restructuring"
                  )
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12 mb-4" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$tc(
                        "profile.rescheduling_restructuring.rescheduling_restructuring"
                      )
                    )
                  ),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
                _vm._v(" "),
                _c("base-text-area", {
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.rescheduling_restructuring.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.rescheduling_restructuring,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "rescheduling_restructuring", $$v)
                    },
                    expression: "formData.rescheduling_restructuring",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.rescheduling_restructuring.$error
                  ? _c("div", [
                      !_vm.$v.formData.rescheduling_restructuring.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.$tc("validation.required"))),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.formData.rescheduling_restructuring.maxLength
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$tc(
                                  "validation.rescheduling_restructuring_maxlength"
                                )
                              )
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c(
                  "base-button",
                  {
                    attrs: {
                      loading: _vm.isLoading,
                      disabled: _vm.isLoading,
                      icon: "save",
                      color: "theme",
                      type: "submit",
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$tc("profile.business_status.save")) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }